module.exports = __webpack_public_path__ + "img/czsdyrmyy.ea3a0f34.png";